import styled from 'styled-components';

export const SwitchGroupLabel = styled.span`
    margin: 0;
    font-size: 14px;
`;
